// @flow
import * as React from 'react';

import { useOptimizely } from './OptimizelyProvider';

export type Props = {
  id: string,
  children: (id: ?string) => React.Node
};

export const OptimizelyExperiment = ({ id, children }: Props) => {
  const { optimizely } = useOptimizely();

  const experiment = optimizely.getExperimentById(id);
  const variationId =
    experiment && experiment.variation ? experiment.variation.id : null;

  return <>{children(variationId)}</>;
};
